var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserFeedbackNotLikeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "100%",
    height: "100%",
    className: "shrink-0 size-4",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 4.5H17A3.5 3.5 0 0 1 20.5 8v4a3.5 3.5 0 0 1-3.5 3.5h-.25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.144 20.5c-1.772 0-2.866-1.933-1.955-3.453l.928-1.547H7.431c-2.476 0-4.169-2.501-3.25-4.8l1.6-4a3.5 3.5 0 0 1 3.25-2.2h6.219v11h-.01l-3.315 4.145a2.28 2.28 0 0 1-1.78.855"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFeedbackNotLikeActive);
export default __webpack_public_path__ + "static/media/user-feedback-not-like-active.ca1b7532261774258a1972825a542fcc.svg";
export { ForwardRef as ReactComponent };